<template>
  <div class="shopping-cart-item">
    <checkout-item-image :src="item.image_path" :alt="item.label" />
    <div style="display: block; text-align: left">
      <checkout-item-description :item="item" />
      <checkout-item-quantity
        :quantity="shoppingCartItem.quantity"
        @quantityUpdated="quantityUpdated"
        @deleteItem="handleDelete"
      />
      <checkout-item-terms
        :terms="getTerms"
        :accepted="shoppingCartItem.terms"
        @updateTerms="updateTerms"
      />
    </div>
  </div>
</template>

<script>
import swal from "sweetalert2";
import store from "../../../../store/stores";
import CheckoutItemImage from "./CheckoutItemImage.vue";
import CheckoutItemTerms from "./CheckoutItemTerms.vue";
import CheckoutItemQuantity from "./CheckoutItemQuantity.vue";
import CheckoutItemDescription from "./CheckoutItemDescription.vue";

export default {
  store,
  components: {
    CheckoutItemDescription,
    CheckoutItemQuantity,
    CheckoutItemTerms,
    CheckoutItemImage,
  },
  props: {
    shoppingCartItem: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      item: null,
    };
  },
  computed: {
    getTerms() {
      return this.$store.getters["checkout/itemMeta"](
        this.shoppingCartItem.item.id,
        "terms"
      );
    },
  },
  beforeMount() {
    this.item = this.shoppingCartItem.item;
  },
  methods: {
    quantityUpdated(quantity) {
      this.$store.dispatch("checkout/updateItemQuantity", {
        cartItemId: this.shoppingCartItem.id,
        quantity,
      });
    },
    updateTerms(val) {
      this.$store.commit("checkout/SET_CART_ITEM_TERMS", {
        cartItemId: this.shoppingCartItem.id,
        boolVal: val,
      });
    },
    handleDelete() {
      swal
        .fire({
          title: "Just checking...",
          type: "question",
          html: `
          <div style="font-size: small">
          <p style="margin: auto">Are you sure you would like to remove</p>
          <p style="max-width: 80%; margin: auto"><b>${this.item.label}</b>
          <p style="margin: auto">from your shopping cart?</p>
          </div>
        `,
          showCancelButton: true,
          cancelButtonText: "No, keep in cart",
          cancelButtonColor: "rgb(92, 184, 92)",
          confirmButtonText: "Yes, remove from cart",
          confirmButtonColor: "rgb(217, 83, 79)",
        })
        .then((result) => {
          if (result.value) {
            this.quantityUpdated(0);
          }
        });
    },
  },
};
</script>

<style scoped>
.shopping-cart-item {
  padding: 2.5rem 1.5rem;
  width: 100%;
  border-bottom: 1px solid #eee;
}

@media (min-width: 768px) {
  .shopping-cart-item {
    display: flex;
  }
}
</style>
